import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Grid } from '@material-ui/core';

import GenericViewPanel from './../GenericViewPanel';
import HazardsList from '../../containers/HazardsList';
import ButtonSearchBoxActionBar from '../ButtonSearchBoxActionBar';
import CreateHazardDialog from '../../containers/CreateHazardDialog';
import EditHazardPanel from '../../containers/EditHazardPanel';
import EditHazardDialog from '../../containers/EditHazardDialog';
import HazardReviewPanel from '../../containers/HazaradReviewPanel';
import HazardManagementLogPanel from '../../containers/HazardManagementLogPanel';
import { hazardStatus } from '../../constants';

import DropDown from '../DropDown';

const useStyles = makeStyles((theme) => ({
  actionBar: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  dropdownSpace: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  leftMargin: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(-6)
  }
}));

const HazardsPanel = (props) => {
  const classes = useStyles();
  const {
    searchTerm,
    handleSearchTermChange,
    openCreateAccidentDialog,
    openPanel,
    openDialog,
    openHazardLogsPanel,
    openHazardReviewPanel,
    selectedStausFilter,
    selectedSortFilter,
    statusFilters,
    descriptionFilters
  } = props;

  const handleHazardTypeFilterChange = (event) => {
    props.onHazardStatsTypeFilterChange(event.target.value);
  };

  const handleHazardSortTypeFilterChange = (event) => {
    props.onHazardSortTypeFilterChange(event.target.value);
  };

  const isPanelOpen =
    openPanel === true ||
    openHazardLogsPanel === true ||
    openHazardReviewPanel === true;

  return (
    <GenericViewPanel>
      <CreateHazardDialog />
      {openDialog ? <EditHazardDialog /> : null}

      {isPanelOpen ? (
        (openPanel ? <EditHazardPanel /> : null) ||
        (openHazardReviewPanel ? <HazardReviewPanel /> : null) ||
        (openHazardLogsPanel ? <HazardManagementLogPanel /> : null)
      ) : (
        <div className={classes.hazardsListAndActionBar}>
          <div className={classes.actionBar}>
            <Grid container>
              <Grid item xs={7} className={classes.searchBoxContainer}>
                <ButtonSearchBoxActionBar
                  openCreateDialog={openCreateAccidentDialog}
                  searchTerm={searchTerm}
                  handleSearchTermChange={handleSearchTermChange}
                  buttonText="Create Hazard"
                  searchPlaceholder="Search hazards"
                />
              </Grid>

              <Grid
                item
                xs={2}
                className={`${classes.dropdownSpace} ${classes.leftMargin}`}
              >
                <DropDown
                  value={selectedSortFilter}
                  handleChange={handleHazardSortTypeFilterChange}
                  items={descriptionFilters}
                  htmlId="gameTypeFilterSelect"
                  valueField="id"
                  displayField="value"
                />
              </Grid>
              <Grid item xs={2} className={classes.dropdownSpace}>
                <DropDown
                  value={selectedStausFilter}
                  handleChange={handleHazardTypeFilterChange}
                  items={statusFilters}
                  htmlId="popularityFilterSelect"
                  valueField="id"
                  displayField="value"
                />
              </Grid>
            </Grid>
          </div>
          <HazardsList />
        </div>
      )}
    </GenericViewPanel>
  );
};

export default HazardsPanel;
